import React, { useState, useEffect } from 'react';
import { defaultRouter, RouteContext, Router } from 'app/common/router';

interface RenderProp {
  children: (routeContext: RouteContext) => React.ReactElement;
  router?: Router;
}

export const RouteContextProvider: React.FunctionComponent<RenderProp> = ({
  children,
  router = defaultRouter,
}) => {
  const [routeState, setRouteState] = useState(router.getRoute());

  useEffect(() => {
    const revoker = router.subscribe(setRouteState);

    return revoker;
  }, [setRouteState, router]);

  return children(routeState);
};
